import Vue from 'vue'
import template from './index.vue'

const BindPhoneConstructor = Vue.extend(template)

let bindPhoneInstance = null
let lastConstructor = null
let lastOptions = null

//options必須帶有reportedId參數傳入被檢舉者Id 
const BindPhone = (options = {}) => {
  let Handler = BindPhoneConstructor

  if (!bindPhoneInstance || lastConstructor !== Handler || lastOptions && lastOptions.chatAvatar) {
    bindPhoneInstance = new Handler({
      el: document.createElement('div')
    })
  }
  lastConstructor = Handler
  lastOptions = options
  const { showNewerReward = false, isOrder = false, isClickOrder = false } = options
  let visible = true
  if (showNewerReward) {
    visible = false
  }
  Object.assign(bindPhoneInstance.$data, options, {
    visible,
    showNewerReward,
    isOrder,
    isClickOrder
  })
  return new Promise((resolve, reject) => {
    bindPhoneInstance.success = () => {
      resolve()
    }
    bindPhoneInstance.fail = () => {
      reject()
    }
    document.body.appendChild(bindPhoneInstance.$el)
  })
}

export default BindPhone